import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Control } from 'react-redux-form';
import { CheckboxInline, FormWrapper, SpinnerPage } from '@common/components';
import { ContractEmailForm, EmailNotificationViewModel } from '@models/Contract';
import FormNames from '@constants/FormNames.enum';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { history } from 'src';

export interface ContractEmailComponentProperties extends RouteComponentProps<{ id: number }> {
  readonly contractId?: number;
  readonly contractEmailList: Array<EmailNotificationViewModel>;
  readonly buttonRef?: (button: HTMLButtonElement) => void;

  readonly getContractEmailList: (contractId: number) => Promise<void>;
  readonly saveContractEmailSelections: (contractId: number, formData: ContractEmailForm, isModal?: boolean) => void;
  readonly saveCallback: () => void;
  readonly setContractEmails: (emailList: Array<EmailNotificationViewModel>) => void;
}

interface ContractEmailState {
  isLoading: boolean;
  numberChecked: number;
  isSaving: boolean;
}

export class ContractEmailComponent extends React.Component<ContractEmailComponentProperties, ContractEmailState> {
  constructor(props: ContractEmailComponentProperties) {
    super(props);
    this.state = {
      isLoading: false,
      numberChecked: 0,
      isSaving: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    let id = this.props.contractId && this.props.contractId > 0 ? this.props.contractId : this.props.match.params.id;
    this.props.getContractEmailList(id).then(() => {
      this.setState({ isLoading: false });
      if (this.props.contractId && this.props.contractId > 0) {
        this.setState({ numberChecked: this.props.contractEmailList.length });
        this.props.setContractEmails(this.props.contractEmailList);
      }
    });
  }

  handleCheckChanged = (event: React.FormEvent<HTMLInputElement>) => {
    let numberChecked = event.currentTarget.checked ? this.state.numberChecked + 1 : this.state.numberChecked - 1;
    this.setState({ numberChecked: numberChecked });
  };

  handleSubmit = (formData: ContractEmailForm) => {
    this.setState({ isSaving: true });
    let id = this.props.contractId && this.props.contractId > 0 ? this.props.contractId : this.props.match.params.id;
    let isModal = this.props.contractId ? true : false;
    this.props.saveContractEmailSelections(id, formData, isModal);
  };

  render() {
    if (this.state.isLoading || this.state.isSaving) {
      return <SpinnerPage />;
    }
    return (
      <FormWrapper
        shouldFormReset={true}
        model={FormNames.ContractEmailForm}
        hideNativeErrors={true}
        onSubmit={this.handleSubmit}
      >
        {!this.props.contractId && <h2>Notifications</h2>}
        {this.props.contractEmailList && this.props.contractEmailList.length ? (
          <>
            <div className="row mb-10 pb-10">
              <div className="col-xs-12">
                {!this.props.contractId ? (
                  <h5>Please select the parties you wish to notify of changes to the Contract Order:</h5>
                ) : (
                  <h3>The following parties will receive a Contract Order Confirmation/Demand Letter:</h3>
                )}
              </div>
            </div>
            {this.props.contractEmailList.map((value, index) => {
              return (
                <div className="row" key={index}>
                  <div className="col-xs-3">
                    <h3>{value.description}</h3>
                    <Control.text
                      className="txt-hidden"
                      model={'.contractEmailList[' + index + '].description'}
                      value={value.description}
                    />
                  </div>
                  <div className="col-xs-9">
                    <CheckboxInline>
                      <Control.checkbox
                        model={'.contractEmailList[' + index + '].email'}
                        value={value.email}
                        onChange={this.handleCheckChanged}
                      />
                      <label htmlFor={FormNames.ContractEmailForm + '.contractEmailList[' + index + '].email'}>
                        {value.email}
                      </label>
                    </CheckboxInline>
                  </div>
                </div>
              );
            })}
            <div className="row end-xs">
              {!this.props.contractId && (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    history.push(
                      this.props.match && this.props.match.params.id
                        ? getRoute(RouteDefinitions.contract.Details, {
                            id: +this.props.match.params.id
                          })
                        : RouteDefinitions.dashboard
                    );
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                className={'btn ' + (this.props.contractId && this.props.contractId > 0 ? 'btn-hidden' : 'btn-primary')}
                type="submit"
                disabled={this.state.numberChecked === 0}
                ref={this.state.numberChecked > 0 ? this.props.buttonRef : ''}
              >
                Send Emails
              </button>
            </div>
          </>
        ) : (
          <div className="row mb-10 pb-10">
            <div className="col-xs-12">
              <h3>No email addresses available for this contract.</h3>
              {this.props.match &&
                this.props.match.params.id && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      history.push(
                        this.props.match && this.props.match.params.id
                          ? getRoute(RouteDefinitions.contract.Details, {
                              id: +this.props.match.params.id
                            })
                          : RouteDefinitions.dashboard
                      );
                    }}
                  >
                    View Contract Details
                  </button>
                )}
            </div>
          </div>
        )}
      </FormWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-email/_components/contract-email.component.tsx